// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-expand {\n  padding-left: 60px;\n  font-size: 0;\n}\n.table-expand label {\n  width: 90px;\n  color: #99a9bf;\n}\n.table-expand label .el-form-item {\n  margin-right: 0;\n  margin-bottom: 0;\n  width: 50%;\n}\n.popover-box {\n  background: #112435;\n  color: #f08047;\n  height: 600px;\n  width: 420px;\n  overflow: auto;\n}\n.popover-box::-webkit-scrollbar {\n  display: none; /* Chrome Safari */\n}", ""]);
// Exports
module.exports = exports;
